import React,{useState} from 'react'
import TodoForm from './TodoForm'
import Todo from './Todo';
function TodoList ()  {
    const [todos, setTodos] = useState([]);
    const addTodo = todo => {
        if(!todo.text || /^\s*$/.test(todo.text)){
            return
        }
        const newTodos = [todo,...todos]
        setTodos(newTodos);  
        console.log(...todos);
    };

    const removeTodo = id =>{
      const removerArr = [...todos].filter(todo=>todo.id !== id)
      setTodos(removerArr)
    }

    const updateTodo = (todoId, newValue)=>{
      if(!newValue.text || /^\s*$/.test(newValue.text)){
        return;
      }
      setTodos(prev => prev.map(item =>(item.id===todoId ? newValue:item)))
    }
    const completeTodo  = id =>{
      let updateTodos = todos.map(todo =>{
        if(todo.id ===id){
          todo.isComplete = !todo.isComplete;
        }
        return todo;
      })
      setTodos(updateTodos);
    }
  return (
    <>
        <h1>What's the plan today?</h1>
        <TodoForm onSubmit={addTodo}/>
        <Todo
        todos={todos} completeTodo={completeTodo} removeTodo={removeTodo} updateTodo={updateTodo}/>

    </>
  )
}

export default TodoList